<template>
    <span class="like-btn" :title="likeTitle">
      <i :class="cls" @click.prevent="addToLikes"></i>
    </span>
</template>

<script>
export default {
  name: `StarVideo`,
  props: {
    video: Object
  },

  methods: {
    addToLikes() {
      this.$store.dispatch(`addToLikes`, this.video);
    }
  },

  computed: {
    inLikes() {
      const list = this.$store.state.user.myVideos.filter((obj) => {
        if (`${obj}` === `${this.video.id}`) {
          return true;
        }
        return false;
      });
      if (list.length > 0) {
        return true;
      }
      return false;
    },

    cls() {
      if (this.inLikes) {
        return `mdi mdi-heart`;
      }
      return `mdi mdi-heart-outline`;
    },

    likeTitle() {
      if (this.inLikes) {
        return `הסר מהשיעורים שלי`;
      }
      return `הוסף לשיעורים שלי`;
    }
  }
};
</script>

<style lang="scss">
$purple: #656b85;
$pinky: #fd7170;

.like-btn {
  .mdi {
    color: $pinky;
    &:hover {
      color: $purple;
    }
  }
}
</style>
